import React from 'react';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';

import PageHeader from 'components/page_header';
import MergeButton from './merge_button';

export default function DuplicatesPageHeader() {
  return (
    <PageHeader
      iconDescription="Manage your company database"
      iconName={faBuilding}
      iconSize="lg"
      iconText="Companies"
      iconType="icon"
    >
      <div className="d-none d-md-inline-block">
        <MergeButton />
      </div>
    </PageHeader>
  );
}
